import React from "react"
import { MainCP } from "../../Components/lugares-compra/MainCP"

const ViewLugaresCompra: React.FC = () => <MainCP/>

export default ViewLugaresCompra